module.exports = __webpack_public_path__ + "img/background-gold-large.d2f97e3c.svg";